import { createClient } from '@supabase/supabase-js';

/**
 * Supabase client.
 *
 * Configuration comes from `import.meta.env`. Both values are non-secret and
 * safe to ship in the frontend bundle:
 *  - VITE_SUPABASE_URL: public project URL (e.g. https://xxx.supabase.co)
 *  - VITE_SUPABASE_PUBLISHABLE_KEY: modern publishable key (sb_publishable_*)
 *
 * The service-role key is NEVER imported here. Service-role operations happen
 * server-side only (DB functions or edge functions with their own keys).
 *
 * Phase 1 "Never Again" rules enforced:
 *  - URL and key come from env vars, NOT hardcoded literals.
 *  - The CI script `scripts/never-again-check.sh` greps to ensure no JWT-
 *    looking literal (eyJ...) appears in source.
 */

const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url) {
  throw new Error(
    'VITE_SUPABASE_URL is not set. Copy .env.example to .env.local and fill in the values.'
  );
}
if (!publishableKey) {
  throw new Error(
    'VITE_SUPABASE_PUBLISHABLE_KEY is not set. Copy .env.example to .env.local and fill in the values.'
  );
}

export const supabase = createClient(url, publishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Cookies are httpOnly via Supabase Auth defaults; we do NOT use localStorage
    // for credential material per the Phase 1 review.
    flowType: 'pkce',
  },
});

export type SupabaseClient = typeof supabase;
